import { z } from "zod";

const baseMedicalInformationSchema = z.object({
  isTakingInsulin: z.enum(["yes", "no"], {
    required_error: "Please select an option",
  }),
});

export const insulinSchema = baseMedicalInformationSchema.extend({
  isTakingInsulin: z.literal("yes"),
  insulinNames: z
    .array(z.string())
    .min(1, { message: "At least one insulin name is required" }),
});

export type InsulinFormType = z.infer<typeof insulinSchema>;

export const noInsulinSchema = baseMedicalInformationSchema.extend({
  isTakingInsulin: z.literal("no"),
  hasLowBloodSugar: z.enum(["yes", "no"], {
    required_error: "Please select an option",
  }),
});

export type NoInsulinFormType = z.infer<typeof noInsulinSchema>;

export const medicalInformationFormSchema = z.discriminatedUnion(
  "isTakingInsulin",
  [insulinSchema, noInsulinSchema],
);

export type MedicalInformationFormType = z.infer<
  typeof medicalInformationFormSchema
>;
